export type Shift = Record<string, any>;
export type ShiftPatch = Partial<Shift>;

export const getUserId = (event: any) => typeof event.user === "object" ? event.user?.id : event.user;

export const toShift = (event: any): Shift => ({
    ...event,
    requestType: "open-shift",
    reason: "",
    payType: "flat",
    payAmount: "",
});
